// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_qi-0";